// Auto-generated skeleton for RecordStatus

export const RecordStatus: Api.RecordStatus = {
  id: 0,
  hp_id: null,
  description: null,
  info_1: null,
  info_2: null,
  created: null,
  updated: null,
};

